export default __webpack_public_path__ + "ca81b0817cb22cca8ff5573dfd753a4c.png";